export default __webpack_public_path__ + "static/media/174.ca21ae5e.gif";